
import store from '@/store'
import ApiClient from '@/common/api'

export default
  created: () ->
    api = new ApiClient()
    await api.get('/partner/login/logout')
    location.href = '/'
